import { FC } from 'react';
import { css } from '@emotion/react';
import { ErrorBoundary, MainBoundary } from '@frontend/error-boundary';
import { SkeletonLoaders } from '@frontend/design-system';
import { ContactPanelTabs } from '../contact-panel';
import { ContactPanelHeader } from '../contact-panel-header';
import { DEMO_PERSON_V3 } from './constant';
import { useDemoContactPanelInterceptors, type DemoContactPanelFeature } from './use-demo-contact-panel-interceptors';

interface DemoContactPanelComponentProps {
  demoLocationId: string;
  demoFeatures: DemoContactPanelFeature[];
}
export const DemoContactPanelComponent: FC<DemoContactPanelComponentProps> = ({ demoLocationId, demoFeatures }) => {
  const { isDemoDataReady } = useDemoContactPanelInterceptors({
    enabled: true,
    demoFeatures,
    locationId: demoLocationId,
  });

  return (
    <ErrorBoundary fallback={MainBoundary} tier='feature' feature='demo-contact-panel' team='fe-analytics'>
      <div css={styles.container}>
        <SkeletonLoaders isLoading={!isDemoDataReady}>
          <ContactPanelHeader personLocationID={demoLocationId} person={DEMO_PERSON_V3} showCloseButton={false} />
        </SkeletonLoaders>
        <ContactPanelTabs
          person={DEMO_PERSON_V3}
          isLoading={!isDemoDataReady}
          personLocationId={demoLocationId}
          syncSelectedTabWithStore={false}
        />
      </div>
    </ErrorBoundary>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    overflow: auto;
  `,
};
